import React, {useState, useEffect} from "react";
import {connect} from "react-redux"
import NumberFormat from "react-number-format";

import CartItem from "./CartItem";


const shopcardStyle = {
    "fontFamily" : "Arial, Helvetica, sans-serif",
    "display": "block",
    "position": "fixed",
    "width": "100px",
    "maxWidth": "180px",
    "border" : "2px solid #ddd"
}

const prodCountStyle = {
    "display": "inline-bloc",
    "color": "white",
    "backgroundColor": "#CCC",
    "fontSize": "0.6rem",
    "marginBottom": "10px"
}


const ShopCart = (props)=>{

    const [asData, setAsData] = useState(false)
    const [products, setProducts] = useState([])
    const [totalPrice, setTotalPrice] = useState(0)
    const [nbProducts, setNbProducts] = useState(0)
    const [tax, setTaxe] = useState(0.2)



    useEffect(()=>{

    }, [])

    useEffect(()=>{
        setProducts(props.products)

    }, [props.products])

    useEffect(()=>{
        setTotalPrice( _.sumBy(props.products, function(o) { return o.price*o.shopQuantity; }));
        setNbProducts(_.sumBy(props.products, function(o) { return o.shopQuantity; }))
    }, [products])

    useEffect(()=>{

        props.setTotalAmount(totalPrice);
        props.setTax(tax)

    },[totalPrice])

    const handleCommande = ()=>{
        props.setCurrentPage('commandProduct')
    }

    const renderItem = (item)=>{
        return ( <CartItem item={item} key={item.id} /> )
    }
    return (
        <div className="card w-100" style={shopcardStyle}>
            <div className="card-header text-center">
                   {    (products && products.length>0)?
                       <h5><i className="fas fa-shopping-cart text-primary"></i><span className={"badge badge-secondary"} style={prodCountStyle}>{nbProducts}</span> <span className={"ml-2"}>pannier</span></h5>
                       :<h5><i className="fas fa-shopping-cart text-primary"></i><span className={"ml-2"}>pannier</span></h5>
                   }
            </div>
                <ul className="list-group list-group-flush">
                    {
                        (products && products.length>0)?
                            products.map(i=>{
                                return renderItem(i);
                            })
                            :<li className="list-group-item">Votre panier est vide !</li>
                    }

                <li className="list-group-item">
                    <div className={"d-flex flex-column justify-content-between border p-1"}>
                        <div    className={"d-flex flex-column justify-content-between"}>
                            <div className={"d-flex flex-row justify-content-end mb-2"}>
                                <strong className={"mr-2"}> H.T. :  </strong>
                                <strong>
                                    <NumberFormat value={totalPrice} displayType={'text'} thousandSeparator={' '} decimalScale={2} suffix={'€'} />

                                </strong>

                            </div>
                            <div  className={"text-right text-muted"} style={{"fontSize": "0.5rem"}}>
                                <strong>Total TTC : </strong>
                                <span>
                                    <NumberFormat value={totalPrice*(1.0+tax)} displayType={'text'} thousandSeparator={' '} decimalScale={2} suffix={'€'} />

                                </span>
                            </div>
                        </div>

                    </div>

                </li>
             </ul>
            <div className="card-footer text-center">
                <a href="#" className={"my-3 btn btn-link"} onClick={props.emptyCart}>vider votre pannier</a>
                <button type="button" className={"btn btn-primary btn-block"} onClick={handleCommande} disabled={props.products.length<=0}>Commander</button>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        products: state.ShopCartReducer.products,

    }
}


const mapDispatchTProps = dispatch => {
    return {
        emptyCart: (e) => dispatch( {type: 'EMPTY_CART'}),
        removeFromCart: (e) => dispatch( {type: 'REMOVE_FROM_CART',  data:{product: e}}),
        addQuantityToCart: (e) => dispatch( {type: 'ADD_QUANTITY', data:{product: e}}),
        subQuantityToCart: (e) => dispatch( {type: 'SUB_QUANTITY', data:{product: e}}),
        setCurrentPage: (e) => dispatch( {type: 'SET_CURRENT_PAGE', data: e}),
        setTotalAmount: (e) => dispatch({type: 'SET_TOTAL_AMOUNT', data: e}),
        setTax: (e) => dispatch({type: 'SET_TAX', data: e}),
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(ShopCart);





